import { __ } from '@wordpress/i18n'

export default {
  pleaseChoose: __('Bitte wählen', 'dhsv_theme'),
}
